import auth from './Auth';
import guest from './Guest';
// import checkRoles from './CheckRoles';

export default {
    auth,
    guest,
    // checkRoles
}